export default "__VITE_ASSET__B96qj2T2__"